import React from 'react';

import { makeStyles } from '@material-ui/styles';
import { useTheme } from 'styled-components';
import { ThemeType } from 'theme/theme';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Content, Title, Message, Toggle, Children, ErrorMessage } from './styles';

export type Props = {
  title: string;
  message?: string;
  errorMessage?: string;
  value: boolean;
  onToggle: (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => void;
  children?: React.ReactNode;
  className?: string;
  isDisabledToggle: boolean;
  hide: boolean;
};

const ToggleCard = ({
  title,
  message,
  errorMessage,
  value,
  onToggle,
  children,
  className,
  isDisabledToggle,
  hide,
}: Props) => {
  const { t } = useStoreTranslation();
  const isError = !isDisabledToggle && !!errorMessage;
  const theme = useTheme() as ThemeType;

  const useStyles = makeStyles(() => ({
    switch_track: {},
    switch_base: {
      color: '#f50057',
      '&.Mui-disabled': {
        color: '#e886a9',
      },
      '&.Mui-checked': {
        color: '#95cc97',
      },
      '&.Mui-checked + .MuiSwitch-track': {
        backgroundColor: theme.secondaryBackgroundColor,
      },
    },
    switch_primary: {
      '&.Mui-checked': {
        color: '#4CAF50',
      },
      '&.Mui-checked + .MuiSwitch-track': {
        backgroundColor: '#4CAF50',
      },
    },
  }));

  return (
    <div>
      <Container className={className} isError={isError} isDisabled={isDisabledToggle} hidden={hide}>
        <Content>
          <div>
            <Title isDisabled={isDisabledToggle}>{title}</Title>
            {message && <Message isDisabled={isDisabledToggle}>{message}</Message>}
          </div>
          <Toggle
            checked={value || false}
            onChange={onToggle}
            disabled={isDisabledToggle}
            classes={{
              track: useStyles().switch_track,
              switchBase: useStyles().switch_base,
              colorPrimary: useStyles().switch_primary,
            }}
          />
        </Content>
        {children && <Children>{children}</Children>}
      </Container>
      {errorMessage && <ErrorMessage>{t(errorMessage)}</ErrorMessage>}
    </div>
  );
};

ToggleCard.defaultProps = {
  isDisabledToggle: false,
};

export default ToggleCard;
